import { Pipe, PipeTransform } from '@angular/core';

const HIGHLIGHT_CLASS = 'search-highlight';

@Pipe({ name: 'highlightSearchText' })
export class OutlookHighlightTextPipe implements PipeTransform {
  transform(value: string | null | undefined, searchPhrase?: string): string {
    if (!value || !searchPhrase) return value ?? '';

    const encoded = escapeHtml(value);
    const encodedPhrase = escapeHtml(searchPhrase);

    return encoded.replace(
      new RegExp(escapeRegExp(encodedPhrase), 'gi'),
      `<span class="${HIGHLIGHT_CLASS}">$&</span>`,
    );
  }
}

function escapeHtml(text: string): string {
  return text
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

function escapeRegExp(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);
}
